import { doesTabSupportPartners } from '@constants/entities/project-dashboard';
import { useDashboard } from '@context/DashboardContext';
import { useProject } from '@context/Project/ProjectProvider';
import useDashboardPartners from '@hooks/dashboard/useDashboardPartners';

const useDashboardPartnerFilter = () => {
  const { options, selected } = useDashboardPartners();
  const { tab } = useDashboard();
  const {
    toolbox: { mode },
  } = useProject();

  return {
    options,
    selected,
    isAvailable: doesTabSupportPartners(mode, tab) && options.length > 0,
  };
};

export default useDashboardPartnerFilter;
